var _defs, _rect, _path, _path2, _path3, _path4, _path5, _path6;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDanhGiaVaTdg(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "13 0 224 224",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:none;}.cls-2{fill:#fbdeb1;}.cls-3{fill:#fdbc42;}"))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 31.07,
    y: 31.07,
    width: 187.87,
    height: 187.87
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M111.53,161c0,14.71-14.19,15.74-31.69,15.74s-31.7-1-31.7-15.74,14.19-26.64,31.7-26.64S111.53,146.23,111.53,161Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M201.86,161c0,14.71-14.19,15.74-31.7,15.74s-31.69-1-31.69-15.74,14.19-26.64,31.69-26.64S201.86,146.23,201.86,161Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M161.91,158.36c0,17.13-16.52,18.33-36.91,18.33s-36.91-1.2-36.91-18.33,16.52-31,36.91-31S161.91,141.22,161.91,158.36Z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M126.52,74.25,131.33,84a5.44,5.44,0,0,0,4.09,3l10.74,1.56a1.7,1.7,0,0,1,1,2.9L139.33,99a5.44,5.44,0,0,0-1.56,4.81l1.83,10.7a1.7,1.7,0,0,1-2.46,1.79l-9.61-5a5.4,5.4,0,0,0-5.06,0l-9.61,5a1.7,1.7,0,0,1-2.46-1.79l1.83-10.7A5.44,5.44,0,0,0,110.67,99l-7.78-7.58a1.7,1.7,0,0,1,1-2.9L114.58,87a5.44,5.44,0,0,0,4.09-3l4.81-9.74A1.69,1.69,0,0,1,126.52,74.25Z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M80.89,91.66l3.33,6.75a3.78,3.78,0,0,0,2.83,2.06l7.45,1.08a1.17,1.17,0,0,1,.65,2l-5.39,5.25a3.78,3.78,0,0,0-1.08,3.33L90,119.54a1.17,1.17,0,0,1-1.7,1.25l-6.66-3.5a3.74,3.74,0,0,0-3.5,0l-6.66,3.5a1.18,1.18,0,0,1-1.71-1.25L71,112.13a3.76,3.76,0,0,0-1.08-3.33l-5.38-5.25a1.17,1.17,0,0,1,.65-2l7.44-1.08a3.74,3.74,0,0,0,2.83-2.06l3.33-6.75A1.18,1.18,0,0,1,80.89,91.66Z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M171.22,91.66l3.33,6.75a3.74,3.74,0,0,0,2.83,2.06l7.44,1.08a1.17,1.17,0,0,1,.65,2l-5.38,5.25a3.76,3.76,0,0,0-1.08,3.33l1.27,7.41a1.18,1.18,0,0,1-1.71,1.25l-6.66-3.5a3.74,3.74,0,0,0-3.5,0l-6.66,3.5a1.17,1.17,0,0,1-1.7-1.25l1.27-7.41a3.78,3.78,0,0,0-1.08-3.33l-5.39-5.25a1.17,1.17,0,0,1,.65-2l7.45-1.08a3.78,3.78,0,0,0,2.83-2.06l3.33-6.75A1.18,1.18,0,0,1,171.22,91.66Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDanhGiaVaTdg);
export default __webpack_public_path__ + "static/media/danh_gia_va_tdg.04fc57056d0c3583d8297b5143e80ae8.svg";
export { ForwardRef as ReactComponent };